// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1082f516","806":"3465b913"}[chunkId] + ".chunk.js";
};